module.exports = __webpack_public_path__ + "img/jobboardy-job-sent.2203bbd3.png";